const DatatableSection = ({ children }) => {
  return <div className="p-4 w-full bg-white border border-gray-200 rounded-xl shadow-sm">{children}</div>;
};

export default DatatableSection;
